import { get } from '../services/api.services';
import { API } from '../constants';

export const fetchFolderNotes = async (token, folderId) => {
    const result = await get(
      `${API.NOTE}?folder_id=${folderId}`,
      token,
    );

    if (result.status === 200) {
        if (result.data.length) {
            return result.data;
        }
    }
    return false;
};

export const fetchSessionNotes = async (token, sessionId) => {
    const result = await get(
      `${API.NOTE}?session_id=${sessionId}`,
      token,
    );

    if (result.status === 200) {
        if (result.data.length) {
            return result.data;
        }
    }
    return false;
};